export default __webpack_public_path__ + "static/exp5-5687d7c014ae6349d382e4be39ea0cf3.png";